<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('menuHistory.automaticBirth')" position="top">
                <vs-switch success v-model="active" class="mt-2 ml-2"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('menuHistory.student')" position="top"
                        v-if="isRouterEmployee() && isPermissionUpdate()">
                <feather-icon icon="UsersIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="manageEmployee"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top" v-if="isPermissionUpdate()">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo" title="Thông tin chi nhánh" :active.sync="openBranchDetails"
                  v-if="openBranchDetails" id="details-branch">
            <ClientInfomation :branchId="params.data.id"></ClientInfomation>
        </vs-popup>
    </div>
</template>

<script>
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";
import ClientInfomation from "../SchoolInfomation";

export default {
    name: 'CellRendererActionsClient',
    components: {
        ClientInfomation,
    },
    data() {
        return {
            openBranchDetails: false,
            status: false
        }
    },
    created() {
        this.status = !!this.params.data.enableWorkShift
    },
    computed: {
        active: {
            get() {
                return this.status
            },
            set(obj) {
                let enableWorkShift = obj ? 1 : 0
                this.saveChanges(enableWorkShift)
            }
        }
    },
    methods: {
        isRouterEmployee() {
            return isRouter(this, constRouter.employee_all);
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.organization_branch_delete);
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.organization_branch_edit);
        },
        manageEmployee() {
            this.$router.push(`/user/student?branch_id=${this.params.data.id}`).catch(() => {
            })
        },
        editRecord() {
            this.openBranchDetails = true;
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá trường "${this.params.data.organizationBranchName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteRecord() {
            this.$vs.loading();
            this.$crm.post(`/organization-branch/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
                branchList = branchList.filter(x => x.id !== this.params.data.id);
                this.$store.dispatch('updateBranchListInfo', branchList);
                return this.showDeleteSuccess();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        showDeleteSuccess() {
            this.$store.commit('DELETE_BRANCH_STATUS', true);
            this.$vs.notify({
                color: 'success',
                text: 'Xoá trường thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
        async saveChanges(enableWorkShift) {
            let url = `/organization-branch/update/${this.params.data.id}`;

            let payload = {
                city: this.params.data.city,
                code: this.params.data.code,
                district: this.params.data.district,
                email: this.params.data.email,
                employeeId: this.params.data.employeeId,
                fullAddress: this.params.data.fullAddress,
                houseNumber: this.params.data.houseNumber,
                organizationBranchName: this.params.data.organizationBranchName,
                organizationBranchType: this.params.data.organizationBranchType,
                organizationId: this.params.data.organizationId,
                phoneNumber: this.params.data.phoneNumber,
                street: this.params.data.street,
                enableWorkShift: enableWorkShift
            }
            this.$vs.loading();
            this.$crm.post(url, payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: 'Cập nhật thông tin trường thành công!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });

                this.$eventBus.$emit("update-branch-success", {});
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },

    mounted() {
        this.$eventBus.$on('update-branch-success', () => {
            this.openBranchDetails = false;
            this.$store.commit('DELETE_BRANCH_STATUS', true);
        })
    },

}
</script>

<style lang="scss">
#details-branch {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
